// Components
import registerAnnotation from '../../../../common/drawings/annotations/index';
import presentationalComponent from './Annotation';
import containerComponent from './AnnotationContainer';

// Constants
import { TOOLS } from '../../../workspace/toolbar/toolbarConstants';

export default () =>
    registerAnnotation({
        presentationalComponent,
        containerComponent,
        tools: [TOOLS.EDIT_DRAWING],
    });
